export default __webpack_public_path__ + "static/thebottomline30-1be122680bc3b67b3eb4b9bdfed06bf5.jpg";